import { isInstalledPwa, isIOS } from './browser';

// iOS Safari supports Web Push only inside an installed PWA (16.4+). For
// non-iOS browsers the OS-level support is uniform, so the iOS-specific
// guard is the only one we need beyond localhost/opt-out.
export function usePushNotifications() {
    return !window.location.hostname.includes('localhost')
        && !localStorage.getItem('disableNotifications')
        && (!isIOS() || isInstalledPwa());
}
